import ReferencePathService from "~/services/referencePathServices/referencePathService";
import {
  IReferencePathNodeSpecific,
  IReferencePathNodeAccountRelationMetadata
} from "~/interfaces/referencePathInterfaces"
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'
import { ReferenceNodeType, ReferenceNodeGenericTypeMap } from "~/enums/referenceNodeType";
import {AccountRelationMetadataType} from "~/enums/accountRelationMetadataType";

export class AccountRelationMetadataPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.ObjectModelProperty

  constructor(private accountRelationMetaDataNode: IReferencePathNodeAccountRelationMetadata) {
    super();
  }

  get label(): string {
    const id = parseInt(this.accountRelationMetaDataNode.reference_id, 10);
    const nodes = this.accountRelationMetaDataNode.parent.nodes;
    const relation = nodes[nodes.length - 2].reference();

    switch (id) {
      case AccountRelationMetadataType.EntityOwnerName:
        return "Entity Owner Name";
      case AccountRelationMetadataType.EntityOwnerEmail:
        return "Entity Owner Email";
      case AccountRelationMetadataType.EntityName:
        return "Entity Name";
      case AccountRelationMetadataType.EntityPhone:
        return "Entity Phone";
      case AccountRelationMetadataType.EntityAddress:
        return "Entity Address";
      case AccountRelationMetadataType.Entity:
        return relation.label_title + " (entity)";
      case AccountRelationMetadataType.EntityOwner:
        return relation.label_title + " (owner)";
      case AccountRelationMetadataType.EntityMembers:
        return relation.label_title + " (members)";
      default:
        console.warn("Add enum value");
        return "--";
    }
  }

  get nodes(): IReferencePathNodeAccountRelationMetadata[] {
    return [this.accountRelationMetaDataNode];
  }

  reference(): ReferenceNodeType {
    return this.accountRelationMetaDataNode.reference_type
  }

  get referenceGenericModelType(): GenericType {
    return ReferenceNodeGenericTypeMap[this.reference()]
  }

  get referenceModelType(): ModelType {
    return ModelType.Text;
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = !node // nothing can be linked to it - end of the line
    this.debugCanLinkTo('ObjectModelPropertyPathService', this.accountRelationMetaDataNode, node, decision)
    return decision;
  }

  get referenceIsCollection(): boolean {
    const id = parseInt(this.accountRelationMetaDataNode.reference_id, 10);
    return id === AccountRelationMetadataType.EntityMembers;
  }

  get referenceIsNotClearable(): boolean {
    const id = parseInt(this.accountRelationMetaDataNode.reference_id, 10);
    return id === AccountRelationMetadataType.EntityOwner;
  }

  get referenceIsRemovable(): boolean {
    const id = parseInt(this.accountRelationMetaDataNode.reference_id, 10);
    return id === AccountRelationMetadataType.EntityMembers;
  }

}